import { useLayoutEffect, useState } from "react";

/**
 * Synchronously answers "could this browser already be signed in?" by looking
 * for a persisted Supabase auth token. Used to paint the public home page
 * immediately instead of waiting for the auth round-trip, without flashing it
 * at visitors who do have a session.
 */
export function useHasStoredSession(): boolean {
  const [has, setHas] = useState(false);

  useLayoutEffect(() => {
    try {
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (key && key.startsWith("sb-") && key.includes("auth-token") && localStorage.getItem(key)) {
          setHas(true);
          return;
        }
      }
    } catch {
      // Storage can be blocked; assume signed out and let auth resolve normally.
    }
  }, []);

  return has;
}
